import { Button, CircularProgress, FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { useSnackbar } from 'notistack';
import * as React from 'react';

import { DataAPIContext, GET_ONE, UPDATE } from '../api';

export const ImportReimportDialog = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const { enqueueSnackbar } = useSnackbar();

    const [sendNotifications, setSendNotifications] = React.useState(props?.data?.input_options?.send_notifications);
    const [editXML, setEditXML] = React.useState(false);
    const [xmlData, setXMLData] = React.useState(null);
    const [syncActive, setSyncActive] = React.useState(false);
    const [originalState, setOriginalState] = React.useState(null);
    const isChanged = (originalState !== xmlData) || (sendNotifications !== props?.data?.input_options?.send_notifications);

    React.useEffect(() => {
        props.setIsXMLDataModified(isChanged)
    }, [isChanged]);

    React.useEffect(() => {
        if (!!xmlData) { return; }
        let active = true;
        dataAPI(GET_ONE, "import_run", { id: props.id, urlSuffix: "input_data/" })
            .then(res => {
                if (!active) { return; }
                if (res.statusCode === 200) {
                    setXMLData(res.data.input_data);
                    setOriginalState(res.data.input_data)
                } else {
                    enqueueSnackbar("Error fetching input data", { variant: 'error' });
                }
            })
        return () => { active = false; }
    }, [dataAPI, xmlData]);

    const onXMLDataChange = (ev) => {
        setXMLData(ev.target.value);
    }

    const onSubmitClick = (ev) => {
        if (syncActive) { return; }
        setSyncActive(true);
        const payload = {
            id: props.id,
            send_notifications: sendNotifications,
            data: editXML ? xmlData: null
        }
        dataAPI(UPDATE, "import_run", { id: props.id, urlSuffix: "resubmit/", data: payload })
            .then(res => {
                if (res.statusCode === 201) {
                    enqueueSnackbar(`XML submitted for another import`, { variant: 'success' });
                    props.onResubmited && props.onResubmited(res.data);
                } else {
                    enqueueSnackbar("Error submitting XML for import", { variant: 'error' });
                }
            })
            .finally(() => setSyncActive(false));
    }

    return (<>
        <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={3}>
                <FormControlLabel
                    control={<Switch checked={sendNotifications} onChange={() => setSendNotifications(p => !p)}/>}
                    label="Send notifications"
                    />
            </Grid>
            <Grid item xs={12} sm={3}>
                <FormControlLabel
                    control={<Switch checked={editXML} onChange={() => setEditXML(p => !p)}/>}
                    label="Edit XML"
                    />
            </Grid>
            <Grid component={Box} item sm={6} display={{ xs: "none" }}></Grid>
            <Grid item xs={12}>
                { xmlData === null ? <>
                    <CircularProgress/>
                </> : <>
                    <TextField
                        sx={{
                            maxHeight: 400,
                            overflowY: 'scroll',
                        }}
                        // inputProps={{
                        //     style: { color: editXML ? null : grey[400] }
                        // }}
                        name="xml"
                        value={xmlData}
                        multiline
                        fullWidth
                        onChange={onXMLDataChange}
                        disabled={!editXML}
                    />
                </> }
            </Grid>
            <Grid item xs={12} container justifyContent="flex-end">
                <Button variant="contained" color="primary" disabled={syncActive} onClick={onSubmitClick}>Submit XML for reimport</Button>
            </Grid>
        </Grid>
    </>)
}

export default ImportReimportDialog;
